import type { ChartMeta, ChartMetaDTO } from '@/widgets/chartsView';
import { baseApi, getErrorMessage } from '@/shared/api';
import type { CalendarDataResponse } from '../model/types';
import type { GetCalendarDataParams } from './types';

export const getMeta = async (): Promise<ChartMeta> => {
  const { data, error } = await baseApi.functions.invoke<{
    calendarInsightsMeta: ChartMetaDTO;
  }>('getComparisonViewMeta');

  if (!data) {
    const errorMessage = getErrorMessage(error);

    throw new Error(errorMessage);
  }

  return data.calendarInsightsMeta;
};

export const getCalendarData = async ({
  split,
  metrics,
  cohortDateScale,
  cohortDateRange,
  revenueDateScale,
  revenueDateRange,
  probabilisticAttribution,
  dimensionsFilters,
  metricsFilters,
}: GetCalendarDataParams) => {
  const { data, error } = await baseApi.functions.invoke<CalendarDataResponse>(
    'getComparisonViewCalendarData',
    {
      body: {
        split,
        metrics,
        cohortDateScale,
        cohortDateRange,
        revenueDateScale,
        revenueDateRange,
        probabilisticAttribution,
        dimensionsFilters,
        metricsFilters,
      },
    },
  );

  if (!data) {
    const errorMessage = getErrorMessage(error);

    throw new Error(errorMessage);
  }

  return data;
};
